import styled from '@emotion/styled';

const StyledH3Div = styled.div({
  display: 'block',
  marginBottom: '30px'
});

export default StyledH3Div;
